require('../../modules/es.string.ends-with');

module.exports = require('../../internals/entry-unbind')('String', 'endsWith');



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/es/string/ends-with.js
// module id = 236
// module chunks = 0